module.exports = {"450202001":"城中街道","450202002":"公园街道","450202003":"中南街道","450202004":"水上街道","450202005":"潭中街道","450202006":"河东街道","450202007":"静兰街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450202.json
// module id = 2081
// module chunks = 0